var map = {
	"./beneficiario.png": 974,
	"./cras.png": 975,
	"./creas.png": 976,
	"./default-avatar.png": 430,
	"./logo.png": 977,
	"./mask.png": 978,
	"./new_logo.png": 979,
	"./pop.png": 980,
	"./reactlogo.png": 981,
	"./sads-logo.png": 278,
	"./secretaria.png": 982,
	"./tim_80x80.png": 983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;